import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  standalone: false
})

export class ErrorComponent implements OnInit {

  constructor(
    public location: Location,
    public translate: TranslateService
  ) { }

  ngOnInit(): void {
  }

}
